/* import __COLOCATED_TEMPLATE__ from './run-jobs.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();